import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLElement> {
  connect(): void {
    this.element.textContent = "Hello World!"
  }
}
